import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Aree from "@/pages/Aree";
import Approccio from "@/pages/Approccio";
import EmdrMacerata from "@/pages/EmdrMacerata";
import Formazione from "@/pages/Formazione";
import Esperienze from "@/pages/Esperienze";
import Faq from "@/pages/Faq";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/chi-sono" element={<ChiSono />} />
          <Route path="/aree-di-intervento" element={<Aree />} />
          <Route path="/aree-intervento" element={<Navigate to="/aree-di-intervento" replace />} />
          <Route path="/approccio" element={<Approccio />} />
          <Route path="/emdr-macerata" element={<EmdrMacerata />} />
          <Route path="/formazione" element={<Formazione />} />
          <Route path="/esperienze" element={<Esperienze />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
